module.exports = __webpack_public_path__ + "static/media/keyboard.6b5de470.svg";